import type { PanelProps } from "../shared";
import { TextRecordsPanel } from "./text-records-panel";

/** Uber carts and past trips; the Activity tab reads this bag, the rest is fixed chrome. */
export function UberPanel(props: PanelProps) {
  return (
    <div className="flex flex-col gap-3">
      <TextRecordsPanel
        {...props}
        path="device.apps.uber.trips"
        title="行程与订单"
        rowTitleKeys={["title", "started_at"]}
        fields={[
          {
            key: "kind",
            label: "类型",
            kind: "enum",
            options: ["ride", "order"],
            optionLabels: { ride: "打车", order: "外卖" },
            clearKeysByValue: { ride: ["items_count"] },
          },
          { key: "title", label: "标题", placeholder: "下车地址或商家名" },
          { key: "started_at", label: "时间" },
          { key: "amount", label: "金额", kind: "number" },
          {
            key: "items_count",
            label: "商品件数",
            kind: "number",
            optional: true,
            visibleWhen: (record) => record.kind === "order",
          },
        ]}
      />
      <TextRecordsPanel
        {...props}
        path="device.apps.uber.carts"
        title="购物车"
        rowTitleKeys={["merchant"]}
        fields={[
          { key: "merchant", label: "商家" },
          { key: "items_count", label: "商品件数", kind: "number" },
          { key: "total", label: "金额", kind: "number" },
          { key: "deliver_to", label: "配送地址" },
        ]}
      />
    </div>
  );
}
